import React, { PureComponent, Fragment } from 'react';
import { createComponent } from '@ycos/fela';
import { hasTag } from '@ycos/coremedia-renderer'

// how many grid units for padding
const layoutVariantMap = {
  'isc-collection': false,
  'isc-collection-large': { desktop: 6, mobile: 4 },
  'isc-collection-medium': { desktop: 4, mobile: 3 },
  'isc-collection-small': { desktop: 3, mobile: 3 }
};

const SpanContainer = createComponent('Spacer', ({ spacing, endSpacing, theme }) => ({
  width: '100%',
  paddingTop: `${spacing.mobile * theme.spacingMultiplier}px`,
  paddingBottom: `${(endSpacing ? endSpacing.mobile : 0) * theme.spacingMultiplier}px`,
  'screen-medium': {
    paddingTop: `${spacing.desktop  * theme.spacingMultiplier}px`,
    paddingBottom: `${(endSpacing ? endSpacing.desktop : 0 ) * theme.spacingMultiplier}px`
  },
  'screen-large': {
    paddingBottom: `${(endSpacing ? endSpacing.largeDesktop : 0 ) * theme.spacingMultiplier}px`
  }
}), 'div');

class Collection extends PureComponent {
  static layoutVariant = Object.keys(layoutVariantMap);

  render() {
    const spacing = layoutVariantMap[this.props.item.layoutVariant];
    const shouldAddPaddingBottom = hasTag(this.props.item.tags, 'Columns.BottomPadding');

    return (
      <Fragment>
        {spacing
          ? this.props.children.map((child, i, children) => {
            const isFirst = i === 0;
            const isLast = i === children.length - 1;
            const innerSpacing = isFirst ? { desktop: 0, mobile: 0 } : spacing;
            const endSpacing = isLast && shouldAddPaddingBottom ? { largeDesktop: 8, desktop: 6, mobile: 3} : undefined;
            return (
              <SpanContainer key={i} spacing={innerSpacing} endSpacing={endSpacing}>
                {child}
              </SpanContainer>
            )
          })
          : this.props.children
        }
      </Fragment>
    )
  }
}

Collection.defaultProps = {
  item: {}
};

export default Collection;
